import type {SidebarLink} from '@github-ui/saved-views'
import {SidebarList} from './components/sidebar-list/SidebarList'
import {SidebarSavedViews} from './components/sidebar-saved-views/SidebarSavedViews'
import type {DashboardTypes} from './types/dashboard-types'

interface DashboardSidebarProps {
  dashboardType: DashboardTypes
  links: SidebarLink[]
  selectedLink: string
  onSelectLink: (linkItem: SidebarLink) => void
  savedViews: SidebarLink[]
  showSavedViews?: boolean
  onCreateView?: () => void
  generateLinkPath: (path: string | undefined, query?: string) => string
}

export function DashboardSidebar({
  dashboardType,
  links,
  selectedLink,
  onSelectLink,
  savedViews,
  showSavedViews = false,
  onCreateView,
  generateLinkPath,
}: DashboardSidebarProps) {
  return (
    <>
      <SidebarList
        dashboardType={dashboardType}
        links={links}
        selectedLink={selectedLink}
        onSelectLink={onSelectLink}
        generateLinkPath={generateLinkPath}
      />
      {showSavedViews && onCreateView && (
        <SidebarSavedViews
          dashboardType={dashboardType}
          savedViews={savedViews}
          selectedLink={selectedLink}
          onSelectLink={onSelectLink}
          onCreateView={onCreateView}
          generateLinkPath={generateLinkPath}
        />
      )}
    </>
  )
}
